import React from "react";
import { gql } from "apollo-boost";

import SettingsList from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createPassengerReadyCommentByAdmin($type: String!) {
    createPassengerReadyCommentByAdmin(input: { type: $type }) {
      _id
      type
    }
  }
`;

const GET = gql`
  query getPassengerReadyCommentsByAdmin($limit: Int, $skip: Int) {
    getPassengerReadyCommentsByAdmin(pagination: { limit: $limit, skip: $skip }) {
      _id
      type
    }
  }
`;

const COUNT = gql`
  query getPassengerReadyCommentsByAdminCount {
    getPassengerReadyCommentsByAdminCount
  }
`;

const UPDATE = gql`
  mutation updatePassengerReadyCommentByAdmin($id: ID!, $type: String!) {
    updatePassengerReadyCommentByAdmin(id: $id, input: { type: $type }) {
      _id
      type
    }
  }
`;

const DELETE = gql`
  mutation removePassengerReadyCommentByAdmin($idSet: [ID!]!) {
    removePassengerReadyCommentByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const FIELDS = [
  {
    name: "type",
    label: "Comment",
    type: "text",
    required: true,
    hint: "Keep it short — it appears as a tappable chip in the app.",
  },
];

/**
 * PassengerReadyComments - the canned remarks a driver taps to
 * describe their passenger at the end of a trip.
 */
const PassengerReadyComments = () => (
  <SettingsList
    title="Passenger ready comments"
    description="What a driver can tap to describe their passenger after a trip."
    singular="comment"
    list={{ query: GET, key: "getPassengerReadyCommentsByAdmin" }}
    count={{ query: COUNT, key: "getPassengerReadyCommentsByAdminCount" }}
    create={{ mutation: ADD, variables: (values) => ({ type: values.type.trim() }) }}
    update={{
      mutation: UPDATE,
      variables: (values, row) => ({ id: row._id, type: values.type.trim() }),
    }}
    remove={{ mutation: DELETE }}
    columns={[{ key: "type", label: "Comment", width: "3fr" }]}
    fields={FIELDS}
    toValues={(row) => ({ type: row.type })}
  />
);

export default PassengerReadyComments;
